import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/main.scss';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.Line1.placeholder',
        defaultMessage: 'Address*',
    },
});

const Line1 = ({
    value,
    autoFocus,
    fieldSize,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur,
    onFocus,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="line1"
            dataTn="line-1"
            value={value}
            wrapperClass={styles.group}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoComplete="address-line1"
            autoFocus={autoFocus}
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
        />
    );
};

Line1.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
};

Line1.defaultProps = {
    autoFocus: false,
    onBlur() {},
};

export default Line1;
